import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DiamondMark } from "./LogoMotif";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export default function MarketNoteCard({ note, tone = "light" }) {
  const isDark = tone === "dark";
  return (
    <Link
      to={`/market-notes/${note.slug}`}
      data-testid={`market-note-card-${note.slug}`}
      className={`group block p-8 md:p-10 border transition-all duration-700 min-h-[320px] relative ${
        isDark
          ? "bg-kingdom text-paper border-white/5 hover:border-gold/50"
          : "bg-white text-charcoal border-charcoal/10 hover:border-gold"
      }`}
    >
      {/* Editorial chapter mark — subtle top-left diamond */}
      <div className="absolute top-6 left-8 opacity-70 group-hover:opacity-100 transition-opacity duration-500">
        <DiamondMark size={10} />
      </div>

      <div className="flex items-center justify-between pl-6">
        <span className="eyebrow">{note.category}</span>
        <span
          className={`text-[11px] uppercase tracking-[0.22em] ${
            isDark ? "text-warm/60" : "text-charcoal/50"
          }`}
        >
          {formatDate(note.date)}
        </span>
      </div>
      <h3
        className={`font-display text-2xl md:text-[26px] mt-8 leading-snug ${
          isDark ? "text-paper" : "text-charcoal"
        }`}
      >
        {note.title}
      </h3>
      <p
        className={`mt-4 text-[15px] leading-relaxed ${
          isDark ? "text-warm/80" : "text-charcoal/70"
        } line-clamp-3`}
      >
        {note.summary}
      </p>
      <div className="mt-10 flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-gold">
        Read note
        <ArrowUpRight
          size={14}
          className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
        />
      </div>
    </Link>
  );
}
